import { Box, Typography, TypographyProps } from '@mui/material';

interface MarketLabelChipProps extends TypographyProps {
  label: string;
}

const MarketLabelChip = ({ label, ...other }: MarketLabelChipProps) => {
  return (
    <Box
      height={'100%'}
      width={'100%'}
      display='flex'
      alignItems='center'
      justifyContent={'start'}
    >
      <Typography fontSize={14} {...other}>
        {label}
      </Typography>
    </Box>
  );
};

export default MarketLabelChip;
